import orciCareLogo from "assets/header-logo-2.jpg";

const PrintEncounterForm = ({ params }) => {
  return (
    <div className="print-encounter-form">
      <div className="header">
        <div className="practice_details">
          <p className="practice_name">{params["practice_name"]}</p>
          <p className="practice_address">{params["practice_address"]}</p>
          <p className="practice_phone">
            Tel. {params["practice_phone"]} / Fax {params["practice_fax"]}
          </p>
          <p className="practice_tax_id">Tax Id {params["practice_tax_id"]}</p>
        </div>
        <div>
          <h1>Encounter Form</h1>
        </div>
        <div className="ins-cont">
          {params["payer_name_primary"] ? (
            <p className="insurance_name">
              Primary: <bold>{params["payer_name_primary"]}</bold>
            </p>
          ) : null}
          {params["payer_name_secondary"] ? (
            <p className="insurance_name">
              Secondary: <bold>{params["payer_name_secondary"]}</bold>
            </p>
          ) : null}
          {params["payer_name_tertiary"] ? (
            <p className="insurance_name">
              Tertiary: <bold>{params["payer_name_tertiary"]}</bold>
            </p>
          ) : null}
        </div>
      </div>
      <div className="patient-details">
        <p className="patient_name">
          Patient: <strong>{params["patient_name"]}</strong>
        </p>
        <p>
          Practice ACCT: <strong>{params["practice_patient_id"]}</strong>
        </p>
        <p className="provider">
          Provider: <strong>{params["provider_name"]}</strong>
        </p>
        <p className="date">
          Date: <strong>{params["encounter_date"]}</strong>
        </p>
      </div>
      <table className="diagnosis-table mt-10">
        <thead>
          <tr>
            <th colspan="3">Diagnosis</th>
          </tr>
        </thead>
        <tbody>
          {params["diagnosis_codes"].length === 0 ? (
            <tr>
              <td colspan="3" style={{ textAlign: "center" }}>
                No Diagnosis Available
              </td>
            </tr>
          ) : null}
          {[...Array(params["dia_third_length"]).keys()].map((i) => (
            <tr>
              <td>
                {params["diagnosis_codes"][i] ? (
                  <div>
                    <span className="code">
                      <input type="checkbox" />
                      {params["diagnosis_codes"][i]["code"]}
                    </span>
                    <span className="descri">
                      {params["diagnosis_codes"][i]["code_description"]}
                    </span>
                  </div>
                ) : null}
              </td>
              <td>
                {params["diagnosis_codes"][i + params["dia_third_length"]] ? (
                  <div>
                    <span className="code">
                      <input type="checkbox" />
                      {
                        params["diagnosis_codes"][
                          i + params["dia_third_length"]
                        ]["code"]
                      }
                    </span>
                    <span className="descri">
                      {
                        params["diagnosis_codes"][
                          i + params["dia_third_length"]
                        ]["code_description"]
                      }
                    </span>
                  </div>
                ) : null}
              </td>
              <td>
                {params["diagnosis_codes"][
                  i + 2 * params["dia_third_length"]
                ] ? (
                  <div>
                    <span className="code">
                      <input type="checkbox" />
                      {
                        params["diagnosis_codes"][
                          i + 2 * params["dia_third_length"]
                        ]["code"]
                      }
                    </span>
                    <span className="descri">
                      {
                        params["diagnosis_codes"][
                          i + 2 * params["dia_third_length"]
                        ]["code_description"]
                      }
                    </span>
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <table className="diagnosis-table  mt-10">
        <thead>
          <tr>
            <th>Office Visits</th>
            <th>Procedures</th>
            <th>Procedures Cont.</th>
          </tr>
        </thead>
        <tbody>
          {params["procedure_codes"].length === 0 ? (
            <tr>
              <td colspan="3" style={{ textAlign: "center" }}>
                No Procedures Available
              </td>
            </tr>
          ) : null}
          {[...Array(params["proc_third_length"]).keys()].map((i) => (
            <tr>
              <td>
                {params["office_visits"][i] ? (
                  <div>
                    <span className="code">
                      <input type="checkbox" />
                      {params["office_visits"][i]["code"]}
                    </span>
                    <span className="descri">
                      {params["office_visits"][i]["code_description"]}
                    </span>
                  </div>
                ) : null}
              </td>
              <td>
                {params["procedure_codes"][i] ? (
                  <div>
                    <span className="code">
                      <input type="checkbox" />
                      {params["procedure_codes"][i]["code"]}
                    </span>
                    <span className="descri">
                      {params["procedure_codes"][i]["code_description"]}
                    </span>
                  </div>
                ) : null}
              </td>
              <td>
                {params["procedure_codes"][i + params["proc_third_length"]] ? (
                  <div>
                    <span className="code">
                      <input type="checkbox" />
                      {
                        params["procedure_codes"][
                          i + params["proc_third_length"]
                        ]["code"]
                      }
                    </span>
                    <span className="descri">
                      {
                        params["procedure_codes"][
                          i + params["proc_third_length"]
                        ]["code_description"]
                      }
                    </span>
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* COMMENTED STUFF */}
      <div className="payment-details">
        <p>
          <span>Recall Date:</span>{" "}
          <span className="underline">{params["recall_date"]}</span>
        </p>
        <p>
          <span>Total Charge:</span>{" "}
          <span className="underline">{params["total_charge"]}</span>
        </p>
        <p>
          <span>Payment:</span>{" "}
          <span className="underline">{params["payment"]}</span>
        </p>
        <p style={{ width: "10%" }}>
          {" "}
          <span className="inline-block" style={{ width: "50%" }}>
            CS
          </span>
          <span className="inline-block" style={{ width: "50%" }}>
            CK
          </span>{" "}
          <br />
          <span
            className="inline-block"
            style={{ width: "70%", textAlign: "center" }}
          >
            CHG
          </span>
        </p>
      </div>

      <table className="end-table">
        <tbody>
          <tr>
            <td>
              <span>PT Portion: </span>
              <span className="underline">
                {"$ "}
                {params["patient_portion_balance"]}
              </span>
            </td>
            <td>
              <span>EEG: </span>
              <span className="underline">{params["eeg"]}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>Insurance Portion: </span>
              <span className="underline">
                {"$ "}
                {params["insurance_portion_balance"]}
              </span>
            </td>
            <td>
              <span>Follow Up: </span>
              {params["weeks"] ? params["weeks"] : "______"} Weeks
              {params["months"] ? params["months"] : "______"} Months
            </td>
          </tr>
          <tr>
            <td>
              <span>Total Balance:</span>
              <span className="underline">
                {"$ "}
                {params["total_balance"]}
              </span>
            </td>
            <td>
              <span>Back For Dictation: </span>
              <span className="underline">{params["back_for_dictation"]}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <img
        src={orciCareLogo}
        width="140"
        alt="logo"
        style={{ position: "absolute", right: 0, bottom: "-5px" }}
      />
    </div>
  );
};

export default PrintEncounterForm;
